module.exports = __webpack_public_path__ + "img/loader.94bb48b7.gif";